export default "__VITE_ASSET__9447a8cb__"